<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="7" md="5" lg="4">
        <login-card>
          <login-form-invira />
        </login-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoginCard from "@dracul/user-frontend/src/pages/LoginPage/LoginCard/LoginCard.vue";
import LoginFormInvira from "./LoginFormInvira.vue";

export default {
  name: "LoginPageInvira",
  components: { LoginCard, LoginFormInvira },
};
</script>
